"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lookupSvc = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant = _interopRequireDefault(require("./constant"));

var lookupSvc = /*#__PURE__*/function () {
  function lookupSvc() {
    (0, _classCallCheck2.default)(this, lookupSvc);
  }

  (0, _createClass2.default)(lookupSvc, null, [{
    key: "getChannelHashList",
    value: function getChannelHashList() {
      var url = "".concat(_constant.default[lookupSvc.environment].GCS_URL, "channel/file.json");
      return _utilities.default.get(url);
    }
    /**
     *  Used for Multi-JWT tokens
     */

  }, {
    key: "getSSRDataJWT",
    value: function getSSRDataJWT(channelId) {
      var env = _constant.default[lookupSvc.environment];
      var ssrUrl = _utilities.default.isChinaDomainName() && lookupSvc.environment === 'PRODUCTION' ? env.SSR_URL_CN : env.SSR_URL;
      var url = ssrUrl + env.SSR_DATA_PATH;
      var body = JSON.stringify({});
      var headersValue = {
        headers: {
          Accept: 'application/json',
          channel_hash: channelId
        }
      };
      return _utilities.default.post(url, headersValue.headers, body);
    }
  }]);
  return lookupSvc;
}();

exports.lookupSvc = lookupSvc;
(0, _defineProperty2.default)(lookupSvc, "environment", '');